export const getModuleByName = (content, name) => {
    return content?.modules.find(m => m.title === name);
};

export const getTabByName = (content, name) => {
    return content?.find(m => m.title === name);
};

export const getThumbnailFromRecommend = data => {
    const image = data?.thumbnails?.image && data.thumbnails.image[0] && data.thumbnails.image[0].url;

    return image || '';
};
